<script setup lang="ts">
defineOptions({ inheritAttrs: false })
</script>

<!-- Material `verified_user` at the 20px Material Symbols scale (glyph 13.33 × 16.67). -->
<template>
  <svg
    width="13.333"
    height="16.667"
    viewBox="0 0 11.3333 14.1667"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    v-bind="$attrs"
  >
    <path
      d="M4.92292 9.59792L8.925 5.59583L7.91563 4.58646L4.92292 7.57917L3.43542 6.09167L2.42604 7.10104L4.92292 9.59792ZM5.66667 14.1667C4.02569 13.7535 2.67101 12.812 1.6026 11.3422C0.534201 9.8724 0 8.24028 0 6.44583V2.125L5.66667 0L11.3333 2.125V6.44583C11.3333 8.24028 10.7991 9.8724 9.73073 11.3422C8.66233 12.812 7.30764 13.7535 5.66667 14.1667ZM5.66667 12.6792C6.89444 12.2896 7.90972 11.5104 8.7125 10.3417C9.51528 9.17292 9.91667 7.87431 9.91667 6.44583V3.09896L5.66667 1.50521L1.41667 3.09896V6.44583C1.41667 7.87431 1.81806 9.17292 2.62083 10.3417C3.42361 11.5104 4.43889 12.2896 5.66667 12.6792Z"
    />
  </svg>
</template>
